import { render, staticRenderFns } from "./DatasetUserPermissions.vue?vue&type=template&id=096cfde0&"
import script from "./DatasetUserPermissions.vue?vue&type=script&lang=js&"
export * from "./DatasetUserPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports